module.exports = __webpack_public_path__ + "img/ic_empty.ae39c96a.png";